exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a {\n  color: #222;\n  display: block;\n  padding-top: 100px;\n  text-decoration: none; }\n\nh1 {\n  font-size: 24;\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/traev/Sites/btt/src/app/public/home/home.component.scss
// module id = ../../../../../src/app/public/home/home.component.scss
// module chunks = main